interface WaveformProps {
  audioHistory: number[];
  isRecording: boolean;
  className?: string;
}

export default function Waveform({ audioHistory, isRecording, className = '' }: WaveformProps) {
  const numBars = Math.max(30, audioHistory.length);
  const bars = Array.from({ length: numBars }, (_, i) => i);

  return (
    <div className={`flex items-center justify-center gap-px ${className}`}>
      {bars.map((bar) => {
        if (!isRecording) {
          return (
            <div
              key={bar}
              className="w-1 bg-bluegray-300 rounded-full"
              style={{
                height: '2px',
                opacity: 0.3
              }}
            />
          );
        }

        // Get the audio level for this bar from history
        const historyIndex = audioHistory.length - numBars + bar;
        const level = historyIndex >= 0 ? audioHistory[historyIndex] : 0;

        // Convert level to height percentage
        const height = Math.max(0.1, level * 3) * 100;

        return (
          <div
            key={bar}
            className="w-1 bg-blue-500 transition-all duration-100 ease-out rounded-full"
            style={{
              height: `${height}%`,
              minHeight: '2px',
              maxHeight: '24px',
              opacity: historyIndex >= 0 ? 0.8 : 0.3
            }}
          />
        );
      })}
    </div>
  );
}
